// @ts-nocheck
import axios from 'axios';
import { isInPWA, platform, isTest, isDev, hasAndroidBridge } from '@/env';
import { useUserInfo } from '@/store';
import md5 from 'crypto-js/md5';
import { ev } from '@/consts'

let curEvs = []
let trackFn = null;
let trackType = '';
let clickid = '';
let trackFlag = false

// facebook
const _init_fb = (pixelId) => {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );
  fbq('init', pixelId);

  trackFn = (eventName, params = {}) => {
    fbq('track', eventName, params);
  }
}

// tiktok
const _init_tt = (pixelId) => {
  !function (w, d, t) {
    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
  var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
  ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
  }(window, document, 'ttq');
  ttq.load(pixelId);
  ttq.page();

  trackFn = (eventName, params = {}) => {
    ttq.track(eventName, params);
  };
}

// kuaishou
const _init_kp = (pixelId) => {
  !function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.install=t():e.install=t()}(window,(function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var r=t[o]={i:o,l:!1,exports:{}};return e[o].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(o,r,function(t){return e[t]}.bind(null,r));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=0)}([function(e,t,n){"use strict";var o=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var o,r=0,i=t.length;r<i;r++)!o&&r in t||(o||(o=Array.prototype.slice.call(t,0,r)),o[r]=t[r]);return e.concat(o||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0});var r=function(e,t,n){var o,i=e.createElement("script");i.type="text/javascript",i.async=!0,i.src=t,n&&(i.onerror=function(){r(e,n)});var a=e.getElementsByTagName("script")[0];null===(o=a.parentNode)||void 0===o||o.insertBefore(i,a)};!function(e,t,n){e.KwaiAnalyticsObject=n;var i=e[n]=e[n]||[];i.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"];var a=function(e,t){e[t]=function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];var i=o([t],n,!0);e.push(i)}};i.methods.forEach((function(e){a(i,e)})),i.instance=function(e){var t,n=(null===(t=i._i)||void 0===t?void 0:t[e])||[];return i.methods.forEach((function(e){a(n,e)})),n},i.load=function(e,o){var a="https://s1.kwai.net/kos/s101/nlav11187/pixel/events.js";i._i=i._i||{},i._i[e]=[],i._i[e]._u=a,i._t=i._t||{},i._t[e]=+new Date,i._o=i._o||{},i._o[e]=o||{};var c="?sdkid=".concat(e,"&lib=").concat(n);r(t,a+c,"https://s16-11187.ap4r.com/kos/s101/nlav11187/pixel/events.js"+c)}}(window,document,"kwaiq")}])}));
  kwaiq.load(pixelId);
  kwaiq.page();

  trackFn = (eventName, params = {}) => {
    kwaiq.instance(pixelId).track(eventName, {pixelId, ...params});
  }
}
const _init_ka = (pixelId) => {
  const url = "//www.adsnebula.com/log/common/api";
  const headers = {
      "Accept": "application/json;charset=utf-8",
      "Content-Type": "application/json"
  };

  trackFn = async (eventName, params = {}) => {
    const jsonPayload = {
        clickid,
        pixelId,
        access_token: "u4P7HH3W64WJWMAjaNJ0Z8et_3l0y9881cWPkcveT58",
        testFlag: false,
        trackFlag: true,
        is_attributed: 1,
        mmpcode: "PL",
        pixelSdkVersion: "9.9.9",
        event_name: eventName // 动态设置事件名称
    };

    try {
      const response = await axios.post(url, Object.assign(jsonPayload, params), { headers });
      console.log("事件已发送！服务器响应：" + response.data);
    } catch (error) {
      console.error("请求错误：", error);
    }

  }
}

const trackName = {
  // 第一次打开页面 - 查看内容
  ViewContent: 'ViewContent',
  // 用户注册成功 - 完成注册
  CompleteRegistration: 'CompleteRegistration',
  // 用户登录成功 - 登录
  SubmitApplication: 'SubmitApplication',
  // 点击进入游戏 - 开始试用游戏
  StartTrial: 'StartTrial',
  // 进入充值页面 - 加入购物车   //进入到充值页面
  AddToCart: 'AddToCart',
  // 创建订单成功 - 拉起订单
  InitiateCheckout: 'InitiateCheckout',
  // 用户完成首次充值 - 首充事件
  Purchase: 'Purchase',
  // ttq 首充事件
  // Subscribe: 'Subscribe',
  // 点击安装PWA后 - 点击安装pwa
  CustomizeProduct: 'CustomizeProduct',
}

const events = {
  fa: ['ViewContent', 'AddToCart'],
  fp: ['ViewContent', 'CompleteRegistration', 'SubmitApplication', 'StartTrial', 'AddToCart', 'InitiateCheckout', 'Purchase'],
  tpl: ['ViewContent', 'CompleteRegistration', 'SubmitForm', 'StartTrial', 'AddToCart', 'InitiateCheckout', 'Subscribe'],
  ka: ['EVENT_CONTENT_VIEW', 'EVENT_ADD_TO_CART'],
  kp: ['contentView', 'completeRegistration', 'buttonClick', 'addToWishlist', 'addToCart', 'initiatedCheckout', 'purchase'],
  // kp: ['EVENT_CONTENT_VIEW', 'EVENT_COMPLETE_REGISTRATION', 'EVENT_BUTTON_CLICK', 'EVENT_ADD_TO_WISHLIST', 'EVENT_ADD_TO_CART', 'EVENT_INITIATED_CHECKOUT', 'EVENT_PURCHASE'],
  apk: ['register', 'login', 'enterGame', 'rechargeClick', 'firstrecharge', 'recharge'],
}

const apk_eventNameMap = {
  CompleteRegistration: 'register',
  // RegClick: 'registerClick',
  SubmitApplication: 'login',
  Logout: 'logout',
  StartTrial: 'enterGame',
  // AddToCart: 'AddToCart',
  InitiateCheckout: 'rechargeClick',
  Purchase: 'firstrecharge',
  Recharge: 'recharge',
}

const tp_eventNameMap = {
  ViewContent: 'ViewContent',
  CompleteRegistration: 'CompleteRegistration',
  SubmitApplication: 'SubmitForm',
  StartTrial: 'StartTrial',
  AddToCart: 'AddToCart',
  InitiateCheckout: 'InitiateCheckout',
  Purchase: 'Subscribe',
}

const KA_eventNameMap = {
  ViewContent: 'EVENT_CONTENT_VIEW',
  CompleteRegistration: 'EVENT_COMPLETE_REGISTRATION',
  SubmitApplication: 'EVENT_BUTTON_CLICK',
  StartTrial: 'EVENT_ADD_TO_WISHLIST',
  AddToCart: 'EVENT_ADD_TO_CART',
  InitiateCheckout: 'EVENT_INITIATED_CHECKOUT',
  Purchase: 'EVENT_PURCHASE',
}

const KP_eventNameMap = {
  ViewContent: {
    ev: 'contentView'
  },
  CompleteRegistration: {
    ev: 'completeRegistration',
    params() {
      return {
        clickid,
        event_name: 'completeRegistration',
        // pixelId,
        access_token: '',
        testFlag: false,
        trackFlag,
        is_attributed: 1,
        mmpcode: 'PL',
        pixelSdkVersion: '9.9.9',
      }
    }
  },
  SubmitApplication: {
    ev: 'buttonClick',
    params() {
      return {
        clickid,
        event_name: 'buttonClick',
        // pixelId,
        access_token: '',
        testFlag: false,
        trackFlag,
        is_attributed: 1,
        mmpcode: 'PL',
        pixelSdkVersion: '9.9.9',
      }
    }
  },
  StartTrial: {
    ev: 'addToWishlist',
    params({gameCode}) {
      return {
        clickid,
        event_name: 'addToWishlist',
        // pixelId,
        access_token: '',
        testFlag: false,
        trackFlag,
        is_attributed: 1,
        mmpcode: 'PL',
        pixelSdkVersion: '9.9.9',
        // properties: {
        //   event_timestamp: Date.now(),
        //   content_type: 'product',
        //   content_id: md5(gameCode),
        //   content_category: md5('CATEGORY'),
        //   content_name: md5('ROOM'),
        // }
      }
    }
  },
  AddToCart: {
    ev: 'addToCart',
  },
  InitiateCheckout: {
    ev: 'initiatedCheckout',
    params({ orderNo, currency, value }) {
      return {
        clickid,
        event_name: 'initiatedCheckout',
        // pixelId,
        access_token: '',
        testFlag: false,
        trackFlag,
        is_attributed: 1,
        mmpcode: 'PL',
        pixelSdkVersion: '9.9.9',
        properties: {
          event_timestamp: Date.now(),
          content_type: 'product',
          content_id: md5(orderNo),
          content_category: md5('Deposit'),
          content_name: md5('Deposit'),
          currency,
          value,
          quantity: 1,
          price: value
        }
      }
    }
  },
  Purchase: {
    ev: 'purchase',
    params({ orderNo, currency, value }) {
      return {
        clickid,
        event_name: 'purchase',
        // pixelId,
        access_token: '',
        testFlag: false,
        trackFlag,
        is_attributed: 1,
        mmpcode: 'PL',
        pixelSdkVersion: '9.9.9',
        properties: {
          event_timestamp: Date.now(),
          content_type: 'product',
          content_id: md5(orderNo),
          content_category: md5('Deposit'),
          content_name: md5('Deposit'),
          currency,
          value,
          quantity: 1,
          price: value
        }
      }
    }
  },
}

const request = axios.create({
  baseURL: import.meta.env.VITE_REPORT_URL
});

const _init = (pixelId: string, type: 'fa' | 'fp' | 'tpl' | 'ka' | 'kp') => {
  console.warn('init', type, pixelId)

  if (!pixelId || !type || !(type in events)) return
  const { clickid: click_id, channelTest, apiOral } = useUserInfo().userInfo || {}

  curEvs = events[type]
  trackType = type
  clickid = click_id
  trackFlag = channelTest

  if (type === 'fa' || type === 'fp') {
    _init_fb(pixelId)
  }

  if (type === 'tpl') {
    _init_tt(pixelId)
  }

  if (type === 'ka') {
    _init_ka(apiOral)
  }

  if (type === 'kp') {
    _init_kp(pixelId)
  }
}

const initApk = () => {
  if (hasAndroidBridge) {
    curEvs = events['apk']
    trackType = 'apk'

    trackFn = (eventName, params = {}) => {
      window.jsBridge.postMessage(eventName, JSON.stringify(params));
    }
  }
}

const init = () => {
  if (hasAndroidBridge) {
    initApk()
    return
  }

  const { channelType, channelPixelId, channelNo } = useUserInfo().userInfo || {channelType: 0, channelPixelId: '', channelNo: 0}
  if (channelNo == 0) return

  if (channelType && channelPixelId) {
    const pixelId = channelPixelId
    _init(pixelId, channelType)
  }
}

const onLogin = () => {
  init()
  
  setTimeout(() => {
    track2Platform(trackName.SubmitApplication)
  }, 500)
}

ev.on('login', () => {
  onLogin()
})

ev.on('restore', (d: any) => {
  if (d[0].userInfo && d[1].$id === 'userInfo') {
    onLogin()
  }
})

ev.on('logout', () => {
  trackFn = null
  trackType = ''
  curEvs = []
  clickid = ''
})

const secretTokens = [
  'product_catalog_id',
]

const track2Platform = (eType: string, params: any = {}) => {
  if (!trackFn || !eType || !trackName[eType]) return
    
  let trackParams = {}
  if (hasAndroidBridge) {
    eType = apk_eventNameMap[eType]
    trackParams = {...params}
  } else {
    const { userid } = useUserInfo().userInfo || {}

    if (trackType === 'tpl') {
      eType = tp_eventNameMap[eType]
      trackParams = {
        event_id: eType + '_' + md5(userid).toString(),
        client_orgin: platform === 'android' ? 'APK' : isInPWA ? 'PWA' : 'website',
        contents: [{
          content_id: Math.random().toString(16).substring(2),
          content_type: 'product',
        }],
        ...params,
      }
    } else if (trackType === 'fa' || trackType === 'fp') {
      trackParams = {
        event_id: eType + '_' + md5(userid).toString(),
        client_orgin: platform === 'android' ? 'APK' : isInPWA ? 'PWA' : 'website',
        ...params,
      }
    } else if (trackType === 'ka') {
      eType = KA_eventNameMap[eType]
    } else if (trackType === 'kp') {
      trackParams = KP_eventNameMap[eType].params && KP_eventNameMap[eType].params(params) || {}
      eType = KP_eventNameMap[eType]?.ev
    }
    
    secretTokens.forEach(token => {
      if (token in trackParams) {
        trackParams[token] = md5(trackParams[token]).toString()
      }
    })
  }

  if (!eType || !curEvs.includes(eType)) return

  console.warn(eType, trackParams)

  trackFn(eType, trackParams);
}

export default function useTrack() {
  return {
    trackName,

    track2Platform,

    track(data) {
      request({
        url: `/info_upload`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          ...data,
          user_ip: localStorage.getItem('clientIp'),
        },
      })
    }
  }
}
